import { Injectable } from "@angular/core";
import { gql, Mutation, Apollo } from "apollo-angular";

export type DeleteFileMutation = {
  deleteIdeaFile: { message: string };
};

export type DeleteFileMutationVariables = {
  id: string;
}

export const deleteFileDocument = gql`
  mutation DeleteIdeaFile($id: String!) {
    deleteIdeaFile(id: $id) {
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class DeleteIdeaFileGQL extends Mutation<
  DeleteFileMutation,
  DeleteFileMutationVariables
> {
  document = deleteFileDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
